
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19797.75 -24591.061 17.701 22.121"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_19_48","data-name":"Symbol 19 – 48","transform":"translate(-21077 -24624)","opacity":".74"}},[_c('g',{attrs:{"id":"Group_6961","data-name":"Group 6961","transform":"translate(108 17)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3560","d":"M1 16.533V8.267A4.083 4.083 0 0 1 5.067 4.2h10","data-name":"Path 3560","transform":"translate(1171 14.933)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1732","d":"M2.133 2.133L0 0","data-name":"Line 1732","transform":"translate(1183.933 17)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1733","d":"M2.133 0L0 2.133","data-name":"Line 1733","transform":"translate(1183.933 19.133)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3561","d":"M18.267 9.3v8.267a4.083 4.083 0 0 1-4.067 4.066h-10","data-name":"Path 3561","transform":"translate(1169.933 13.233)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1734","d":"M0 0l2.133 2.133","data-name":"Line 1734","transform":"translate(1174.133 34.867)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1735","d":"M0 2.133L2.133 0","data-name":"Line 1735","transform":"translate(1174.133 32.733)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1736","d":"M0 2.469L2.469 0","data-name":"Line 1736","transform":"rotate(180 590 12.868)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1737","d":"M0 0v6.537","data-name":"Line 1737","transform":"rotate(180 590 14.975)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_1738","d":"M2.469 2.397L0 0","data-name":"Line 1738","transform":"rotate(180 591.235 12.832)"}})])])])
          )
        }
      }
    